export default __webpack_public_path__ + "static/media/marcascarpe.b3fdb747.png";